import React from 'react';

export default ({ className, ...other }) => (
  <svg
    {...other}
    className={`icon wthumb ${className || ''}`}
    viewBox="0 0 57.053 73.964"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      xmlns="http://www.w3.org/2000/svg"
      id="Symbol_1_1"
      data-name="Symbol 1 – 1"
      transform="translate(0)"
    >
      <path
        id="Path_79"
        data-name="Path 79"
        d="M-1113.422-61.634c-.425-.023-.852-.082-1.275-.062a7.732,7.732,0,0,1-5.324-1.951c-.3-.244-.6-.493-.928-.76-.454.318-.9.646-1.359.943a1.1,1.1,0,0,1-.55.179c-2.351.032-4.7.062-7.055.059a9.249,9.249,0,0,1-1.983-.187,4.051,4.051,0,0,1-2.8-3.646c-.053-2.414-.089-4.829-.086-7.243q.011-7.546.076-15.093c.008-1.067.077-2.135.148-3.2a1.76,1.76,0,0,1,.24-.743,4.234,4.234,0,0,1,3.786-2.332c2.05-.014,4.1,0,6.149-.009a4.155,4.155,0,0,1,3.306,1.268.752.752,0,0,0,.985.156,23.133,23.133,0,0,0,4.984-2.551,11.527,11.527,0,0,0,3.985-4.915,6.6,6.6,0,0,0,.406-2.475c.063-2.829.1-5.659.162-8.488.018-.829.08-1.657.126-2.485a.92.92,0,0,1,.6-.85,7.574,7.574,0,0,1,1.711-.53,13.41,13.41,0,0,1,4.356.162,6.823,6.823,0,0,1,4.773,3.819,8.5,8.5,0,0,1,.95,3.733c.113,3.292.16,6.585.233,9.878,0,.16,0,.32,0,.523h.519c3.5.016,6.993.018,10.489.056a10.571,10.571,0,0,1,3.436.354,7.9,7.9,0,0,1,5.6,6.825,10.709,10.709,0,0,1-.225,2.958q-1.048,6.836-2.158,13.663c-.368,2.256-.755,4.511-1.217,6.749a6.9,6.9,0,0,1-3.8,4.971c-.893.449-1.857.756-2.793,1.117a1.184,1.184,0,0,1-.409.039q-2.867.015-5.735.027a3.464,3.464,0,0,0-.37.041Zm-6.328-29.876c0,.126,0,.2,0,.275q.057,11.49.118,22.979a.906.906,0,0,0,.086.4,7.768,7.768,0,0,0,1.744,2.253,3.08,3.08,0,0,0,1.795.793,19.021,19.021,0,0,0,1.955.148q12.639-.02,25.277-.072a5.253,5.253,0,0,0,4.706-4.029q.673-3.842,1.282-7.7.994-6.311,1.941-12.629a6.191,6.191,0,0,0,.152-2.053,4.831,4.831,0,0,0-4.5-4.215c-.587-.06-1.181-.069-1.771-.071-3.509-.015-7.018-.014-10.527-.036a22.5,22.5,0,0,1-2.332-.135.949.949,0,0,1-.887-1.041c-.044-3.257-.076-6.515-.134-9.772a23.426,23.426,0,0,0-.169-3.123,5.127,5.127,0,0,0-6.2-4.226c-.333.065-.408.2-.409.516-.009,2.943-.036,5.886-.056,8.829a10.645,10.645,0,0,1-2.44,6.819,18.982,18.982,0,0,1-5.248,4.426A13.745,13.745,0,0,1-1119.75-91.51Zm-12.081,12.118c0,3.948.011,7.9-.014,11.845a1.4,1.4,0,0,0,.524,1.2,1.686,1.686,0,0,0,1.168.33q2.565.017,5.13-.006a6.927,6.927,0,0,0,1.271-.141.964.964,0,0,0,.9-1.062c.03-.628.069-1.256.072-1.884q.044-11.185.077-22.37a1.246,1.246,0,0,0-1.068-1.233c-2.323-.033-4.647-.015-6.97-.015a.375.375,0,0,0-.075.009,1.375,1.375,0,0,0-1.011,1.223Z"
        transform="translate(1134.777 135.598)"
        fill="currentColor"
      />
      <path
        id="Path_80"
        data-name="Path 80"
        d="M-1082-27.888c-2.324-.056-4.649-.1-6.973-.173a1.226,1.226,0,0,1-.958-1.663,4.821,4.821,0,0,1,.675-.9.5.5,0,0,1,.339-.1q6.26,0,12.519.018c.427,0,.854.037,1.28.066a1.345,1.345,0,0,1,1.244,1.029,1.762,1.762,0,0,1-.608,1.506,1.042,1.042,0,0,1-.5.1q-3.506.01-7.013,0Z"
        transform="translate(1093.408 56.147)"
        fill="currentColor"
      />
      <path
        id="Path_81"
        data-name="Path 81"
        d="M-762.758-360.525q0,2.83,0,5.659a1.718,1.718,0,0,1-1.424,1.459c-.939.028-1.23-.175-1.368-1.113a16.116,16.116,0,0,1-.163-2.216c-.023-3.194-.024-6.389-.019-9.583a.77.77,0,0,1,.216-.477c1.04-1.072,1.513-1.071,2.544.011a.839.839,0,0,1,.2.525C-762.753-364.349-762.758-362.437-762.758-360.525Z"
        transform="translate(793.589 367.599)"
        fill="currentColor"
      />
      <path
        id="Path_82"
        data-name="Path 82"
        d="M-620.373-282.2a1.313,1.313,0,0,1-1.378-1.045,1.036,1.036,0,0,1,.168-.8,13.48,13.48,0,0,1,1.364-1.653c2.2-2.223,4.431-4.422,6.651-6.628.107-.106.225-.2.335-.3a1.076,1.076,0,0,1,1.3-.284c.542.286,1.069.655,1,1.368a1.711,1.711,0,0,1-.386.9c-.692.8-1.415,1.568-2.16,2.314q-2.759,2.761-5.552,5.488A1.614,1.614,0,0,1-620.373-282.2Z"
        transform="translate(660.498 298.663)"
        fill="currentColor"
      />
      <path
        id="Path_83"
        data-name="Path 83"
        d="M-1004.8-281.393a3.7,3.7,0,0,1-.9-.474q-2.753-2.63-5.46-5.308c-.918-.911-1.806-1.855-2.664-2.823a1.334,1.334,0,0,1,.373-2.138,1.223,1.223,0,0,1,1.467.112c1.526,1.459,3.048,2.923,4.548,4.408,1.1,1.087,2.161,2.211,3.237,3.321a4.661,4.661,0,0,1,.542.626,1.231,1.231,0,0,1,.152,1.348A1.686,1.686,0,0,1-1004.8-281.393Z"
        transform="translate(1023.308 298.008)"
        fill="currentColor"
      />
      <path
        id="Path_84"
        data-name="Path 84"
        d="M-583.651-30.726h5.7a1.384,1.384,0,0,1,1.341,1.662,4.071,4.071,0,0,1-.615,1.06c-.039.059-.179.074-.271.074q-5.752-.031-11.5-.073a4.868,4.868,0,0,1-.749-.081.944.944,0,0,1-.934-1.031,1.736,1.736,0,0,1,.444-1.285.9.9,0,0,1,.595-.23c2-.017,4-.01,6-.01Z"
        transform="translate(631.755 56.152)"
        fill="currentColor"
      />
    </g>
  </svg>
);
